import React, { useState } from 'react';
import axios from 'axios';

const AddOfficeBearer = () => {
    const [formData, setFormData] = useState({
        name: '',
        designation: '',
    });
    const [profileImage, setProfileImage] = useState(null);
    const [profilePreview, setProfilePreview] = useState(null);

    const designations = [
        'President',
        'Vice President',
        'General Secretary',
        'Joint Secretary',
        'Treasurer',
        'Member',
    ];

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleProfileChange = (e) => {
        const file = e.target.files[0];
        setProfileImage(file);

        // Generate preview
        setProfilePreview(URL.createObjectURL(file));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
    
        if (!profileImage) {
            alert('Please upload an image');
            return;
        }
    
        const reader = new FileReader();
        reader.readAsDataURL(profileImage);  // this converts file to base64
    
        reader.onloadend = async () => {
            const base64Image = reader.result;
    
            const payload = {
                name: formData.name,
                designation: formData.designation,
                image: base64Image, // send as base64 string
            };
    
            try {
                const response = await axios.post(`${process.env.REACT_APP_REQUESTING_API}/api/officebearers`, payload, {
                    headers: { 'Content-Type': 'application/json' }
                });
    
                alert(response.data.message);
    
                // Clear fields after successful submission
                setFormData({ name: '', designation: '' });
                setProfileImage(null);
                setProfilePreview(null);
            } catch (error) {
                console.error(error);
                alert('Failed to add office bearer');
            }
        };
    };
    
    return (
        <div>
            <form
                onSubmit={handleSubmit}
                className="space-y-6 p-4 mt-32 border rounded-lg shadow-md bg-white max-w-md mx-auto"
            >
                <h1 className="text-2xl font-bold text-center">Add Office Bearer</h1>

                <div>
                    <label htmlFor="name" className="block font-semibold">
                        Name
                    </label>
                    <input
                        type="text"
                        name="name"
                        value={formData.name}
                        placeholder="Enter Name"
                        onChange={handleChange}
                        className="block w-full p-2 border rounded mt-1"
                        required
                    />
                </div>

                <div>
                    <label htmlFor="designation" className="block font-semibold">
                        Designation
                    </label>
                    <select
                        name="designation"
                        value={formData.designation}
                        onChange={handleChange}
                        className="block w-full p-2 border rounded mt-1"
                        required
                    >
                        <option value="">Select Designation</option>
                        {designations.map((designation, index) => (
                            <option key={index} value={designation}>
                                {designation}
                            </option>
                        ))}
                    </select>
                </div>

                <div>
                    <label htmlFor="profileImage" className="block font-semibold">
                        Upload Profile Image
                    </label>
                    <input
                        type="file"
                        name="profileImage"
                        onChange={handleProfileChange}
                        accept="image/*"
                        className="block w-full mt-1"
                        required
                    />
                    {profilePreview && (
                        <img
                            src={profilePreview}
                            alt="Profile Preview"
                            className="w-24 h-24 mt-2 object-cover border rounded"
                        />
                    )}
                </div>

                <button
                    type="submit"
                    className="w-full px-4 py-2 text-white bg-zinc-600 rounded hover:bg-zinc-500"
                >
                    Add Office Bearer
                </button>
            </form>
        </div>
    );
};

export default AddOfficeBearer;
